import { ValidSemanticColors } from '../theme/_generated/ValidSemanticColors';

export const ColorVars: Record<string, ValidSemanticColors> = {
  primary: ValidSemanticColors.TextPrimary,
  secondary: ValidSemanticColors.TextSecondary,
  info: ValidSemanticColors.TextSecondary,
  error: ValidSemanticColors.TextValidationDanger,
  success: ValidSemanticColors.TextValidationSuccess,
  warning: ValidSemanticColors.TextValidationWarning,
};
